import { Observable } from 'rxjs';
import { DestinationsResponse } from '../models/destinations.model';

export abstract class DestinationsRepository {
    abstract getDestinations(): Observable<DestinationsResponse>;
}
